import { CouvertTranslations } from ".";

export const COVERT_FR_FR: CouvertTranslations = {
	label: "Modifier couverts",
	editCouvert: "Modifier couvert",
	newCouvert: "Ajouter couvert",
	saveChanges: "Sauvegarder les modifications",
	createCouvert: "Créer couvert",
	male: "Masculin",
	female: "Féminin",
	mesas: "Mesas",
	edit: "Modifier",
	add: "Ajouter",
	active: "Actif",
	disabled: "Inactif",
	cancel: "Annuler",
	delete: "Supprimer",
	emptyState: {
		title: "Il n'y a encore rien ici",
		subtitle: "Lorsque vous ajouterez un nouveau couvert, il apparaîtra ici.",
	},
	deleteModal: {
		title: "Voulez-vous supprimer ce couvert ?",
		firstDescription:
			"En confirmant, vous ne pourrez plus voir le couvert et ne pourrez plus l'appliquer dans les opérations PDV.",
		secondDescription: "Les enregistrements du rapport resteront dans l'historique.",
		cancel: "Annuler",
		confirm: "Supprimer couvert",
	},
	columns: {
		public: "Public",
		name: "Nom",
		category: "Catégorie",
		price: "Prix",
		fiscalProfile: "Profil Fiscal",
		fiscalProductGroup: "Groupe de Produits Fiscaux",
	},
	placeholders: {
		name: "Définissez le nom de votre Couvert",
		public: "Sélectionnez le public",
		category: "Sélectionnez la catégorie",
	},
	alert: {
		title:
			"En activant le mode fiscal, les couverts ont été désactivés. Mettez à jour les données fiscales des couverts pour les réactiver.",
		message:
			"Les données fiscales des couverts sont obligatoires pour l'émission fiscale. Si vous n'avez pas encore de données fiscales sur les couverts, ajoutez-les ",
		action: "en cliquant ici",
	},
	error: {
		value: {
			required: "Ce champ est obligatoire",
			value: "Le montant du couvert doit être inférieur ou égal à la limite postpayée",
		},
		name: {
			required: "Le nom est obligatoire",
			maxLength: "Le nom peut contenir jusqu'à {{maxLength}} caractères",
		},
		category: {
			required: "La catégorie est obligatoire",
			maxLength: "La catégorie peut contenir jusqu'à {{maxLength}} caractères",
		},
		kind: {
			required: "Public est obligatoire",
		},
	},
};
